export default function ContactSection() {
  return (
    <section className="py-24 md:py-32 px-8 md:px-16 bg-background-50">
      <div className="max-w-5xl mx-auto flex flex-col items-center">
        {/* Title */}
        <h2 className="font-sans text-4xl md:text-6xl font-bold text-foreground-900 text-center">
          Contact
        </h2>

        {/* Subtitle */}
        <p className="mt-4 text-lg md:text-xl text-foreground-400 font-body text-center font-light leading-relaxed">
          Reach out to discuss how we can work together
        </p>

        {/* Contact info block */}
        <div className="mt-16 text-center space-y-2">
          <p className="text-base md:text-lg text-foreground-700 font-body leading-relaxed">
            Saare tee 10-2
          </p>
          <p className="text-base md:text-lg text-foreground-700 font-body leading-relaxed">
            Povvatu kula, 62212
          </p>
          <p className="text-base md:text-lg text-foreground-700 font-body leading-relaxed">
            +372 82722442
          </p>
          <p className="text-base md:text-lg text-foreground-700 font-body leading-relaxed">
            contact@kasarsoftware.com
          </p>
        </div>

        {/* Divider */}
        <div className="mt-20 w-[40%] h-px bg-foreground-200/40" />

        {/* Bottom anchor area */}
        <div className="mt-10 w-full flex flex-col sm:flex-row items-center justify-between">
          {/* Left: oversized typographic element */}
          <span className="font-heading text-[100px] md:text-[140px] font-bold text-foreground-200/25 leading-none select-none">
            /
          </span>

          {/* Right: auxiliary text */}
          <span className="text-sm text-foreground-400 font-body font-light mt-4 sm:mt-0">
            Engineering excellence, built to last
          </span>
        </div>

        {/* Bottom margin */}
        <div className="h-20" />
      </div>
    </section>
  );
}